import ownerDocument from './ownerDocument';

import getOffset from 'dom-helpers/query/offset';
import getPosition from 'dom-helpers/query/position';
import getScrollTop from 'dom-helpers/query/scrollTop';

const utils = {
  getContainerDimensions(containerNode) {
    let width;
    let height;
    let scroll;

    if (containerNode.tagName === 'BODY') {
      width = window.innerWidth;
      height = window.innerHeight;

      scroll =
        getScrollTop(ownerDocument(containerNode).documentElement) || getScrollTop(containerNode);
    } else {
      ({ width, height } = getOffset(containerNode));
      scroll = getScrollTop(containerNode);
    }

    return { width, height, scroll };
  },

  getPosition(target, container) {
    return container.tagName === 'BODY' ? getOffset(target) : getPosition(target, container);
  },

  calcOverlayPosition({ placement, overlayNode, target, container, padding, isCentering }) {
    const childOffset = this.getPosition(target, container);

    const { height: overlayHeight, width: overlayWidth } = getOffset(overlayNode);

    let positionLeft;
    let positionTop;
    let arrowOffsetLeft;
    let arrowOffsetTop;

    if (placement === 'left' || placement === 'right') {
      positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

      if (placement === 'left') {
        positionLeft = childOffset.left - overlayWidth;
      } else {
        positionLeft = childOffset.left + childOffset.width;
      }

      // eslint-disable-next-line no-use-before-define
      const topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

      positionTop += topDelta;
      arrowOffsetTop = `${50 * (1 - (2 * topDelta) / overlayHeight)}%`;
      // eslint-disable-next-line no-void
      arrowOffsetLeft = void 0;
    } else if (placement === 'top' || placement === 'bottom') {
      positionLeft = childOffset.left;

      if (isCentering) {
        positionLeft += (childOffset.width - overlayWidth) / 2;
      }

      if (placement === 'top') {
        positionTop = childOffset.top - overlayHeight;
      } else {
        positionTop = childOffset.top + childOffset.height;
      }

      // eslint-disable-next-line no-use-before-define
      const leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
      positionLeft += leftDelta;
      arrowOffsetLeft = `${50 * (1 - (2 * leftDelta) / overlayWidth)}%`;
      arrowOffsetTop = undefined;
    } else {
      throw new Error(`calcOverlayPosition(): No such placement of "${placement}" found.`);
    }

    return { positionLeft, positionTop, arrowOffsetLeft, arrowOffsetTop };
  },
};

function getTopDelta(top, overlayHeight, container, padding) {
  const containerDimensions = utils.getContainerDimensions(container);
  const containerScroll = containerDimensions.scroll;
  const containerHeight = containerDimensions.height;

  const topEdgeOffset = top - padding - containerScroll;
  const bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  }
  if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  }

  return 0;
}

function getLeftDelta(left, overlayWidth, container, padding) {
  const containerDimensions = utils.getContainerDimensions(container);
  const containerWidth = containerDimensions.width;

  const leftEdgeOffset = left - padding;
  const rightEdgeOffset = left + padding;

  let delta = 0;

  if (leftEdgeOffset < 0) {
    delta = -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    delta = containerWidth - rightEdgeOffset + (containerWidth - overlayWidth);
  }
  // ситуация с неправильным отображением окна с ошибкой https://onetwotripdev.atlassian.net/browse/PS-1165
  if (left + overlayWidth + delta > containerWidth) {
    delta = containerWidth - overlayWidth - left;
  }
  // если вдруг дельта получится слишком большой
  if (left + delta < 0) {
    delta = -left;
  }

  return delta;
}

export default utils;
